import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import BotSubmissionForm from '@/components/BotSubmissionForm';

const SubmitBot = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-border bg-background/80 backdrop-blur-sm sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Button
                variant="ghost"
                onClick={() => navigate('/')}
                className="flex items-center gap-2"
              >
                <ArrowLeft className="w-5 h-5" />
                <span>Back to Home</span>
              </Button>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
                <img src="/lovable-uploads/77d0311e-683d-4bfc-9330-af043621a127.png" alt="Vergo AI" className="w-6 h-6" />
              </div>
              <h1 className="text-xl font-bold text-foreground">
                Vergo
              </h1>
            </div>
          </div>
        </div>
      </header>

      {/* Submit Bot Page Content */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-foreground mb-4">
              Submit Your AI Bot
            </h1>
            <p className="text-xl text-muted-foreground">
              Share your AI bot with our community and help others discover amazing tools
            </p>
          </div>

          <BotSubmissionForm />
        </div>
      </section>
    </div>
  );
};

export default SubmitBot;